var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30854 2.27275C9.30854 1.96463 9.05876 1.71484 8.75064 1.71484C8.44251 1.71484 8.19273 1.96463 8.19273 2.27275V7.44268H3.02275C2.71463 7.44268 2.46484 7.69246 2.46484 8.00058C2.46484 8.3087 2.71463 8.55848 3.02275 8.55848H8.19273V13.7284C8.19273 14.0365 8.44251 14.2863 8.75064 14.2863C9.05876 14.2863 9.30854 14.0365 9.30854 13.7284V8.55848H14.4784C14.7865 8.55848 15.0363 8.3087 15.0363 8.00058C15.0363 7.69246 14.7865 7.44268 14.4784 7.44268H9.30854V2.27275Z",
    fill: "#005FC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.1f58df28ca68870409dba60836d84ee8.svg";
export { ForwardRef as ReactComponent };